// vSpin-win.js - 抽奖转盘倒计时与按钮控制脚本

// 自执行匿名函数，避免全局变量污染
(function(){
  /**
   * 模拟弹窗功能
   */
  function createModal() {
    // 创建遮罩层
    var overlay = document.createElement('div');
    overlay.className = 'spin-modal-overlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
      opacity: 0;
      transition: opacity 0.3s ease;
    `;

    // 创建弹窗内容
    var modal = document.createElement('div');
    modal.className = 'spin-modal';
    modal.style.cssText = `
      background-color: white;
      padding: 30px;
      border-radius: 10px;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
      max-width: 500px;
      width: 90%;
      text-align: center;
      transform: translateY(-20px);
      transition: transform 0.3s ease;
    `;

    // 创建消息内容
    var message = document.createElement('div');
    message.className = 'spin-modal-message';
    message.style.cssText = `
      margin-bottom: 20px;
      font-size: 16px;
      line-height: 1.5;
    `;

    // 创建确认按钮
    var confirmBtn = document.createElement('button');
    confirmBtn.className = 'spin-modal-button';
    confirmBtn.textContent = 'OK';
    confirmBtn.style.cssText = `
      padding: 10px 30px;
      background-color: #000;
      color: white;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      font-size: 16px;
      transition: background-color 0.3s ease;
    `;

    // 按钮悬停效果
    confirmBtn.addEventListener('mouseenter', function() {
      confirmBtn.style.backgroundColor = '#333';
    });
    confirmBtn.addEventListener('mouseleave', function() {
      confirmBtn.style.backgroundColor = '#000';
    });

    // 关闭弹窗事件
    function closeModal() {
      overlay.style.opacity = '0';
      modal.style.transform = 'translateY(-20px)';
      setTimeout(function() {
        document.body.removeChild(overlay);
      }, 300);
    }

    // 点击确认按钮关闭弹窗
    confirmBtn.addEventListener('click', closeModal);

    // 点击遮罩层关闭弹窗
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        closeModal();
      }
    });

    // ESC键关闭弹窗
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeModal();
      }
    });

    // 组装弹窗
    modal.appendChild(message);
    modal.appendChild(confirmBtn);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    // 显示弹窗动画
    setTimeout(function() {
      overlay.style.opacity = '1';
      modal.style.transform = 'translateY(0)';
    }, 10);

    return {
      message: message,
      close: closeModal
    };
  }

  /**
   * 显示模拟弹窗
   * @param {string} message - 弹窗消息内容
   */
  function showModal(message) {
    var modal = createModal();
    modal.message.textContent = message;
  };
  /**
   * 倒计时计时器功能
   * 为页面上所有计时器元素设置实时倒计时
   */
  function expireTimer(){
    // 获取所有计时器元素
    document.querySelectorAll("#_v-spin-win-container .timer-countdown").forEach(function (timer) {
      // 从data-time属性获取时间，移除秒数部分
      var rawDate = timer.dataset.time.replace(/:\d{2}$/, "");
      // 将时间转换为时间戳
      var countDownDate = new Date(rawDate).getTime();

      if (countDownDate) {
        // 每秒更新一次倒计时
        var x = setInterval(function () {
          // 获取当前时间戳
          var now = new Date().getTime();
          // 计算剩余时间
          var time_distance = countDownDate - now;

          // 计算天、时、分、秒
          var days = Math.floor(time_distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((time_distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((time_distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((time_distance % (1000 * 60)) / 1000);

          // 更新页面上的倒计时显示，确保两位数格式
          timer.querySelector("#days").textContent = ("0" + days).slice(-2);
          timer.querySelector("#hours").textContent = ("0" + hours).slice(-2);
          timer.querySelector("#minutes").textContent = ("0" + minutes).slice(-2);
          timer.querySelector("#seconds").textContent = ("0" + seconds).slice(-2);

          // 当倒计时结束时，清除计时器并将所有值设为00
          if (time_distance < 0) {
            clearInterval(x);
            timer.querySelectorAll("#days, #hours, #minutes, #seconds").forEach(function (el) {
              el.textContent = "00";
            });
          }
        }, 1000);
      }
    });
  }

  // 页面加载完成后执行
  document.addEventListener("DOMContentLoaded", function () {
    // 为抽奖按钮添加点击事件监听
    document.querySelector(".btn-wrapper .button").addEventListener("click", function () {
      // 延迟300毫秒后触发CrazyRocket弹窗
      setTimeout(() => {
        const rocketBtn = document.getElementById("crazyrocket-launch-icon")
        if (rocketBtn) {
          rocketBtn.click();
        }
      }, 300);
    });

    // 当点击弹窗外部区域时，强制关闭CrazyRocket弹窗
    document.addEventListener('click', function(event) {
      // 获取已完成的抽奖数据
      var spin_completed = localStorage.getItem("crazyrocket_completed");
      var spin_completed_data = JSON.parse(spin_completed);
      // 获取弹窗iframe
      var iframe = document.querySelector('#crazyrocket-iframe-container iframe');

      // 如果点击的是弹窗遮罩层且已有完成的抽奖记录，则查找并点击关闭按钮
      if(iframe && event.target.id == 'crazyrocket-popup-overlay' && spin_completed_data.length > 0 ){
        var close_button = iframe.contentDocument.querySelector('.crazyrocket-close-symbol, .close_button_label');
        if(close_button){
          close_button.click()
        }
      }
    });

    // 将用户留言添加到弹幕中
    function addCommentToBarrage(commentData) {
      // 获取所有弹幕轨道
      var tracks = document.querySelectorAll('.scroll-left');
      if (tracks.length === 0) return;

      // 随机选择一个轨道
      var randomTrack = tracks[Math.floor(Math.random() * tracks.length)];
      var trackInner = randomTrack.querySelector('.track-inner');

      // 创建新的弹幕气泡
      var newBubble = document.createElement('div');
      newBubble.className = 'bubble marked';

      // 格式化时间
      var timeString = 'Just now';

      // 设置弹幕内容
      newBubble.innerHTML = `
        <div class="bubble-user">
          <span class="user-name">${commentData.name}</span>
          <span class="comments-time">${timeString}</span>
        </div>
        <div class="bubble-comments">${commentData.comment}</div>
      `;

      // 将新弹幕添加到轨道末尾
      trackInner.appendChild(newBubble);

      // 如果轨道有两个track-inner（如原始代码中的结构），也添加到第二个
      var trackInners = randomTrack.querySelectorAll('.track-inner');
      if (trackInners.length > 1) {
        var secondTrackInner = trackInners[0];
        var clonedBubble = newBubble.cloneNode(true);
        secondTrackInner.appendChild(clonedBubble);
      }
    }

    // 加载所有用户留言到弹幕
    function loadUserCommentsToBarrage() {
      var userComments = JSON.parse(localStorage.getItem("user_comments")) || [];
      userComments.forEach(function(comment) {
        addCommentToBarrage(comment);
      });
    }

    // 页面加载时，将所有用户留言添加到弹幕
    loadUserCommentsToBarrage();

    // 为留言提交按钮添加点击事件监听
    var commentSubmitBtn = document.querySelector('.comment-submit-btn');
    if (commentSubmitBtn) {
      commentSubmitBtn.addEventListener('click', function() {
        var nameInput = document.querySelector('.comment-name-input');
        var textareaInput = document.querySelector('.comment-textarea');

        var name = nameInput.value.trim();
        var comment = textareaInput.value.trim();

        // 简单的表单验证
        if (name && comment) {
          // 存储用户留言到localStorage
          var userComments = JSON.parse(localStorage.getItem("user_comments")) || [];
          var commentData = {
            name: name,
            comment: comment,
            timestamp: new Date().toISOString()
          };
          userComments.push(commentData);
          localStorage.setItem("user_comments", JSON.stringify(userComments));

          // 将新留言添加到弹幕
          addCommentToBarrage(commentData);

          // 判断是否为首次提交
          var isFirstSubmission = !localStorage.getItem("comment_submitted");

          // 标记留言已提交
          localStorage.setItem("comment_submitted", "true");
          commentSubmitted = true;

          // 清空表单
          nameInput.value = '';
          textareaInput.value = '';

          // 重新计算抽奖机会
          lockButton();

          // 提示用户留言提交成功
          if (isFirstSubmission) {
            showModal('Comment submitted successfully! You now have 1 chance to spin the wheel.');
          } else {
            showModal('Comment submitted successfully!');
          }
        } else {
          showModal('Please enter both name and comment.');

        }
      });
    }

    // 为留言文本域添加字符计数功能
    var textarea = document.querySelector('.comment-textarea');
    var charCount = document.querySelector('.comment-char-count');
    if (textarea && charCount) {
      textarea.addEventListener('input', function() {
        var currentLength = this.value.length;
        var maxLength = this.getAttribute('maxlength');
        charCount.textContent = currentLength + '/' + maxLength;
      });
    }
  });

  // 初始化变量
  var spinsUsed = parseInt(localStorage.getItem("usfed_spin_used")) || 0; // 已使用的抽奖次数
  var spinButton = document.querySelector('.btn-wrapper .button'); // 打开抽奖页面按钮
  var socialClicked = sessionStorage.getItem("social_button_clicked") === 'true'; // 社交分享按钮是否被点击
  var chance = document.querySelector('.btn-wrapper .chance'); // 剩余机会容器
  var chance_num = chance.querySelector('.chance-num'); // 剩余机会数字
  var commentSubmitted = localStorage.getItem("comment_submitted") === 'true'; // 留言是否已提交

  /**
   * 获取CrazyRocket触发器按钮
   * @returns {HTMLElement|null} 触发器按钮元素
   */
  function getTriggerBtn() {
    return document.getElementById("crazyrocket-launch-icon");
  }

  // 观察DOM变化，当抽奖弹窗关闭时执行相应操作
  const observer = new MutationObserver((mutations, obs) => {
    mutations.forEach((mutation) => {
      var seven_iframe = document.getElementById("lucky-seven-iframe-site")
      if(seven_iframe) {
        const iframeDoc = seven_iframe.contentDocument || seven_iframe.contentWindow.document;
        const spin_button =  iframeDoc.getElementById('spin-button')
        if(spin_button) {
          spin_button.onclick = function () {
            const email_input = iframeDoc.getElementById('email_input_text').value
            const p_checkbox = iframeDoc.getElementById('privacy-checkbox').value
            if (email_input && p_checkbox) {
              console.log('抽奖了')
              spinsUsed++; // 增加已使用抽奖次数
              localStorage.setItem("usfed_spin_used", spinsUsed); // 保存已使用次数到localStorage
              // 重新计算抽奖机会
              lockButton();
            }
          }
          console.log('停止观察')
          observer.disconnect();
        }
      }
    });
  });

  // 开始观察DOM变化
  observer.observe(document.body, { childList: true, subtree: true });

  /**
   * 锁定/解锁抽奖按钮功能
   * 根据已使用抽奖次数、社交分享和留言提交情况控制按钮状态
   */
  function lockButton(){
    // 获取所有社交分享按钮
    var shareButton = document.querySelectorAll('.social-wrapper a');

    // 计算总抽奖机会数
    var totalChances = 1; // 默认1次机会

    // 第一次留言增加1次机会
    if (commentSubmitted) {
      totalChances++;
    }

    // 第一次分享增加1次机会
    if (socialClicked) {
      totalChances++;
    }

    // 计算剩余机会数
    var remainingChances = Math.max(0, totalChances - spinsUsed);

    // 更新按钮状态和剩余机会显示
    spinButton.disabled = remainingChances <= 0;
    chance_num.textContent = remainingChances.toString();

    // 为抽奖按钮添加点击事件监听
    spinButton.addEventListener('click', () => {
      var triggerBtn = getTriggerBtn();

      // 获取当前剩余机会数
      var currentChances = parseInt(chance_num.textContent);

      // 如果没有触发器按钮且还有剩余机会，重新初始化CrazyRocket
      if (!triggerBtn && currentChances > 0) {
        window.CrazyRocket.init(); // 重新初始化CrazyRocket，显示弹窗
      }
    });

    // 为社交分享按钮添加点击事件监听
    shareButton.forEach(btn => {
      btn.addEventListener('click', () => {
        var triggerBtn = getTriggerBtn();
        // 标记社交分享按钮已被点击
        sessionStorage.setItem('social_button_clicked', 'true');
        socialClicked = sessionStorage.getItem("social_button_clicked") === 'true';

        // 重新计算抽奖机会
        lockButton();

        // 如果没有触发器按钮且还有剩余机会，重新初始化CrazyRocket
        var currentChances = parseInt(chance_num.textContent);
        if (!triggerBtn && currentChances > 0) {
          window.CrazyRocket.init(); // 重新初始化CrazyRocket，显示弹窗
        }
      });
    });
  }

  // 初始化倒计时功能
  expireTimer();
  // 初始化按钮锁定功能
  lockButton();
})();
